import React from 'react';
import Header from '../navigation/headerContainer';
import Footer from '../navigation/footerContainer';

export default function PageNotFound(){
  return (
    <>
      <Header />
        <main className="home">
            <div className='background'>
                <div className="mainName">
                    <span className="mainText">404 :(</span>
                </div>

                <div className="nameSlogan">
                    <span className="slogan">Page Not Found</span>
                </div>
            </div>

        </main>
    <Footer />
    </>
  );
};
